import type {
  IntelligentBaselineRequestDto,
  IntelligentBaselineUsageRequestDto,
  AnnualUsageRequestDto,
  IntelligentBaselineResponseDto,
} from "./genability.types"
import axiosInstance from "../../api.axiosInstance"
import type { GenabilitySavingsDto } from "../../dto/genability.dot"

export class GenabilityService {
  private static readonly BASE_PATH = `/genability/v1`

  static async estimateFromMonthlyCosts(
    request: IntelligentBaselineRequestDto,
  ): Promise<IntelligentBaselineResponseDto> {
    const { data } = await axiosInstance.post<IntelligentBaselineResponseDto>(
      `${GenabilityService.BASE_PATH}/intelligent-baseline/monthly-costs`,
      request,
    )
    return data
  }

  static async estimateFromMonthlyUsage(
    request: IntelligentBaselineUsageRequestDto,
  ): Promise<IntelligentBaselineResponseDto> {
    const { data } = await axiosInstance.post<IntelligentBaselineResponseDto>(
      `${GenabilityService.BASE_PATH}/intelligent-baseline/monthly-usage`,
      request,
    )
    return data
  }

  static async estimateFromAnnualUsage(
    request: AnnualUsageRequestDto,
  ): Promise<IntelligentBaselineResponseDto> {
    const { data } = await axiosInstance.post<IntelligentBaselineResponseDto>(
      `${GenabilityService.BASE_PATH}/intelligent-baseline/annual-usage`,
      request,
    )
    return data
  }

  async fetchSavings(
    genabilityAccountId: string,
  ): Promise<GenabilitySavingsDto> {
    const { data } = await axiosInstance.get<GenabilitySavingsDto>(
      `${GenabilityService.BASE_PATH}/savings-analysis/${genabilityAccountId}`,
    )
    return data
  }
}
